var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOperationalForecastBags = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M10.6 9.819v-3.89c0-.329.269-.596.6-.596h9.6c.331 0 .6.267.6.596v3.89h5.628c.537 0 .972.432.972.965v14.918a.97.97 0 0 1-.972.965H4.972A.97.97 0 0 1 4 25.702V10.784c0-.533.435-.965.972-.965zm1.2 0h8.4V6.852a.53.53 0 0 0-.532-.528h-7.336a.53.53 0 0 0-.532.528z",
  clipRule: "evenodd"
})));
export default SvgOperationalForecastBags;